import React, { useState } from "react";
import PageBanner from "../components/PageBanner";
import { HERO_IMAGES } from "../mock";
import { createLead } from "../api";
import { useToast } from "../hooks/use-toast";
import { Send } from "lucide-react";

const Wanted = () => {
  const [form, setForm] = useState({ name: "", email: "", make: "", budget: "", details: "" });
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await createLead({ type: "sourcing", name: form.name, email: form.email, make: form.make, budget: form.budget, message: form.details });
      toast({ title: "Request received", description: "Thank you — our team will start the search and be in touch soon." });
      setForm({ name: "", email: "", make: "", budget: "", details: "" });
    } catch (err) {
      toast({ title: "Something went wrong", description: "Please try again shortly.", variant: "destructive" });
    }
  };

  return (
    <div className="bg-white">
      <PageBanner title="Car Sourcing" subtitle="Tell us what you are looking for and let our specialists do the searching." image={HERO_IMAGES[1]} />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-gray-600 leading-relaxed mb-8 text-center">
          We source classic cars and motorcycles for clients across the country. Whether you are hunting for a
          specific model or want us to find the very best example available, our sourcing service takes the
          hard work out of the search.
        </p>
        <form onSubmit={submit} className="space-y-4 p-8" style={{ backgroundColor: "#f4f2ea" }}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm bg-white" />
            <input required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="px-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm bg-white" />
            <input placeholder="Make / Model wanted" value={form.make} onChange={(e) => setForm({ ...form, make: e.target.value })} className="px-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm bg-white" />
            <input placeholder="Budget (£)" value={form.budget} onChange={(e) => setForm({ ...form, budget: e.target.value })} className="px-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm bg-white" />
          </div>
          <textarea rows={5} placeholder="Tell us more about what you are looking for..." value={form.details} onChange={(e) => setForm({ ...form, details: e.target.value })} className="w-full px-4 py-3 border border-black/15 outline-none focus:border-[var(--gpm-green)] text-sm bg-white" />
          <button type="submit" className="flex items-center justify-center gap-2 w-full py-4 gpm-text-cream text-sm font-semibold uppercase tracking-wider transition-transform hover:-translate-y-0.5" style={{ backgroundColor: "var(--gpm-green)" }}>
            <Send size={16} /> Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default Wanted;
